export default __webpack_public_path__ + "static/bb-logo-black-1d1523a2a0da9ad310651ae69ccac7e2.png";